import { useColorModeContext } from "../color-mode";
import colorful from "./map-styles/colorful";
import dark from "./map-styles/dark";
import light from "./map-styles/light";
import { useMapStore } from "./store";

export const MapTypes = ["hybrid", "roadmap", "satellite", "terrain"] as const;
export type MapType = (typeof MapTypes)[number];
export const MapStyles = ["light", "dark", "colorful", "auto"] as const;
export type MapStyle = (typeof MapStyles)[number];

const mapStyles = { dark, light, colorful };

export const defaultCamera = {
	center: {
		lng: 13.4067,
		lat: 52.5194,
	},
	zoom: 12,
};

export function useMapStyle() {
	const store = useMapStore();
	const { colorMode } = useColorModeContext();
	const mapStyle = store.mapStyle === "auto" ? mapStyles[colorMode] : mapStyles[store.mapStyle];
	return mapStyle;
}
